import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { actionButton } from "./classNames";

var ActionButton = function ActionButton(props) {
  return React.createElement("button", _extends({
    type: "button",
    className: actionButton
  }, props));
};

export default ActionButton;